import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fr: { translation: fr },
        },
        fallbackLng: 'fr', // Default to French as per recent changes
        interpolation: {
            escapeValue: false, // React already safes from xss
        },
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage', 'cookie'],
        },
    });

export async function setTrainingRouteLocale(locale) {
    if (locale !== 'fr' && locale !== 'en') {
        throw new TypeError(`Unsupported training locale: ${locale}`);
    }

    document.documentElement.lang = locale;

    if (i18n.language !== locale) {
        await i18n.changeLanguage(locale);
    }
}

/**
 * The mentoring section is also path-authoritative, but it has its own
 * namespace so failures name the right feature.
 */
export async function setMentoringRouteLocale(locale) {
    if (locale !== 'fr' && locale !== 'en') {
        throw new TypeError(`Unsupported mentoring locale: ${locale}`);
    }

    document.documentElement.lang = locale;

    if (i18n.language !== locale) {
        await i18n.changeLanguage(locale);
    }
}

export default i18n;
